<template minapp="mpx" xlang="wxml">
  <controllable-drawer-bottom
    customStyle="{{customStyle}}"
    headerStyle="{{headerStyle}}"
    show="{{show}}"
    useDefaultIcon="{{false}}"
    bind:close="closeDrawer"
  >
    <image
      class="close-icon"
      slot="close-icon"
      src="https://ut-static.udache.com/webx/sfc/v5Jr29yGXupbYCt1_5w8U.png"
    />
    <view class="container" wx:style="{{computedContainerStyle}}">
      <view class="title">
        <image
          class="name"
          src="{{title}}"
          mode="heightFix"
        />
        <view class="rights-desc">{{ rightsTitle }}</view>
      </view>
      <view class="content" bindscroll="handleScroll">
        <Swiper class="mb-28" itemSize="320" swiperList="{{swiperList}}" bindchange="changeIndex" />
        <view class="rule-wrapper">
          <view class="rule-text-list" wx:style="{{showMoreStyle}}" wx:ref="listref">
            <view wx:if="{{showMoreBtn}}" class="show-more" bindtap="showMoreFun"
              >展开更多<spring-icon class="bottom-thin-arrow" w="16" h="9" name="bottom-thin-arrow"
            /></view>
            <view class="rule-text-item">
              {{ ruleText[curIndex] }}
            </view>
          </view>
        </view>
      </view>
      <view class="footer" wx:if="{{!nofooter}}">
        <view class="footer-content">
          <view class="footer-price">
            <view class="unit">¥</view>
            <view class="ticket-price">{{ ticketPrice }}</view>
            <view class="service-price">+¥{{ servicePrice }}退改无忧</view>
          </view>
          <view class="footer-btn" bindtap="chooseRight"> 立即购买 </view>
        </view>
      </view>
    </view>
  </controllable-drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getFinalPrice } from '@/utils/money'
  import { trackEvent } from '@/common/track'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
      regularService: { // 用于区分埋点
        type: Boolean,
        value: false
      },
      hideFooter: {
        type: Boolean,
        value: false
      },
      // 时机 0为填单页成单前 1为订单页成单后
      timing: {
        type: Number,
        value: 0
      }
    },
    data() {
      return {
        curIndex: 0,
        scrollTop: 0,
        headerStyle: {
          paddingTop: 0
        },
        containerStyle: {
          backgroundSize: '100% auto',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          borderRadius: '20px 20px 0 0'
        },
        showMore: false,
        showMoreBtn: true,
        scrollHeight: 153,
      }
    },
    watch: {
      show(val) {
        if (val) {
          this.getShowMoreStatus()
          // 有购票footer 在填单页
          if (!this.nofooter) {
            trackEvent(
              'yks_train_detailpage_showfloat_sw',
              '迎客松-火车票-车次详情页-产品说明浮层-曝光',
              this.trackParams
            )
          }
          // 从填单页-可选择辅营商品-打开
          if (this.regularService) {
            trackEvent(
              'yks_train_conorder_showfloat_sw',
              '迎客松-火车票-确认订单页-产品说明浮层-曝光',
              { servicetype: 'noworries' }
            )
          }
        }
      },
      curIndex(val, oldVal) {
        if (val !== oldVal) {
          this.getShowMoreStatus()
        }
      }
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo',
        selectRightInfo: 'train.selectRightInfo',
        rightCardType: 'makeOrder.rightCardType',
      }),
      ...store.mapGetters({
        worryfreeRightPopupInfo: 'train.worryfreeRightPopupInfo',
        orderDetailWorryfreeRightPopupInfo: 'order.orderDetailWorryfreeRightPopupInfo'
      }),
      // 选择完权益后不展示footer
      nofooter() {
        return this.selectRightInfo.length > 0 || this.hideFooter
      },
      customStyle() {
        return {
          height: this.nofooter ? '507px' : '607px',
          borderRadius: '20px 20px 0 0',
          overflow: 'hidden'
        }
      },
      showMoreStyle() {
        return this.showMore ? {} : { maxHeight: '187px' }
      },
      computedContainerStyle() {
        // const url = this.scrollTop > 5 ? 'https://ut-static.udache.com/webx/sfc/9z_mfho6PVJnw_OgXdsBb.png' : 'https://ut-static.udache.com/webx/sfc/N5xjOOl7Sezx0fuVjQv9G.png'
        const url = 'https://ut-static.udache.com/webx/sfc/N5xjOOl7Sezx0fuVjQv9G.png'
        // const imageSize = this.scrollTop > 5 ? '100% 96px' : '100%'
        return {
          ...this.containerStyle,
          backgroundImage: `url(${url})`
        }
      },
      ticketPrice() {
        const price = this.selectSeatInfo?.reduce(
          (pre, cur) =>
            pre +
            (this.isExemption
              ? Number(cur?.highest_ticket_price || cur?.ticket_price || 0)
              : Number(cur?.ticket_price || 0)),
          0
        )
        return getFinalPrice(price)
      },
      servicePrice() {
        const price = this.selectSeatInfo
          .map((item) => {
            const service = item?.service_info?.serviceInfoList?.find(
              (item) => item && item?.type === 2
            )
            return service?.fee || 0
          })
          .reduce((pre, cur) => pre + cur, 0)
        return getFinalPrice(price)
      },
      trackParams() {
        return {
          servicetype: 'noworries',
          tagtype: this.rightCardType
        }
      },
      title() {
        return this.timing === 1 ? this.orderDetailWorryfreeRightPopupInfo.pop_title : this.worryfreeRightPopupInfo.pop_title
      },
      rightsTitle() {
        return this.timing === 1 ? this.orderDetailWorryfreeRightPopupInfo.pop_sub_title : this.worryfreeRightPopupInfo.pop_sub_title
      },
      swiperList() {
        return this.timing === 1 ? this.orderDetailWorryfreeRightPopupInfo.image_list : this.worryfreeRightPopupInfo.image_list
      },
      ruleText() {
        return this.timing === 1 ? this.orderDetailWorryfreeRightPopupInfo.text_list : this.worryfreeRightPopupInfo.text_list
      }
    },
    methods: {
      closeDrawer() {
        this.triggerEvent('close')
      },
      showMoreFun() {
        this.showMore = true
        this.showMoreBtn = false
      },
      handleScroll(e) {
        const top = e.detail?.scrollTop || e.target?.scrollTop
        this.scrollTop = top
      },
      chooseRight() {
        trackEvent(
          'yks_train_detailpage_showfloat_subscribe_ck',
          '迎客松-火车票-车次详情页-产品说明浮层-预定-点击',
          this.trackParams
        )
        this.triggerEvent('chooseRight')
      },
      changeIndex(e) {
        this.curIndex = e.detail.current
      },
      getShowMoreStatus() {
        this.showMore = false
        this.showMoreBtn = false
        setTimeout(() => {
          this.scrollHeight =
            this.$refs?.__mpx_ref_listref__?.scrollHeight || this.$refs?.listref?.scrollHeight || 153
          this.showMoreBtn = this.scrollHeight >= 153
        }, 0)
      }
    }
  })
</script>

<style scoped lang="stylus">
  .mb-28
    margin-bottom 28px
    height 200px
    flex-shrink 0
  .bg-img
    width 100%
    position absolute
    top 0
    left 0
    z-index 1
  .close-icon
    height 28px
    width 28px
  .container
    height 100%
    z-index 2
    display flex
    justify-content flex-start
    flex-direction column
    box-sizing border-box
    overflow auto
    .title
      flex-shrink 0
      height 96px
      display flex
      flex-direction column
      align-items center
      padding-top 22px
      box-sizing border-box
      .name
        height 40px
      .rights-desc
        font-size 12px
        font-family PingFangSC-Medium
        font-weight 500
        color #FFFFFF
    .content
      flex 1
      height 0
      display flex
      flex-direction column
      align-items center
      overflow auto
      padding-bottom 8px
      box-sizing border-box
      .rule-wrapper
        width calc(100% - 32px)
        position relative
        box-sizing border-box
        padding 16px 12px
        border-radius 10px
        background #fef7f5
        color #666
        border 0.5px solid rgba(184, 112, 72, 0.3)
        &::before
          z-index 1
          content ''
          position absolute
          height 15px
          width 15px
          left 50%
          top 0
          transform translate(-50%, -50%) rotate(-45deg)
          background #fef7f5
          border 0.5px solid rgba(184, 112, 72, 0.3)
          border-left none
          border-bottom none
        .rule-text-list
          position relative
          font-size 12px
          line-height 17px
          overflow hidden
          transition max-height 0.3s ease-in-out
          .show-more
            z-index 1
            background #fef7f4
            position absolute
            bottom 0
            right 0
            display flex
            align-items center
            color #5F88C8
            &::after
              content ''
              position absolute
              bottom 0
              left 0
              width 12px
              height 100%
              background linear-gradient(to left, #fff, rgba(255, 255, 255, 0.1))
              z-index 2
              transform translateX(-100%)
            .bottom-thin-arrow
              margin-left 3px
          .rule-text-item
            display flex
            align-items flex-start
            white-space pre-line
    .footer
      margin-top 4px
      box-sizing border-box
      height 100px
      width 100%
      padding 11px 14px 39px 16px
      border-radius 10px 10px 0 0
      box-shadow inset 0px 1px 0px 0px #EEEEEE
      .footer-content
        display flex
        justify-content space-between
        align-items center
        .footer-price
          display flex
          align-items baseline
          .unit
            font-size 16px
            font-family PingFangSC-Semibold
            font-weight 600
            color #FF6400
            margin-right 1px
          .ticket-price
            font-family Barlow Semi Condensed
            font-size 32px
            line-height 32px
            font-weight 400
            color #FF6400
            margin-right 4px
          .service-price
            font-size 11px
            line-height 16px
            color #666
        .footer-btn
          border-radius 10px
          line-height 16px
          padding 17px 38px
          box-sizing border-box
          display flex
          justify-content center
          align-items center
          background #FF6400
          font-family PingFangSC-Medium
          font-weight 500
          color #fff
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'controllable-drawer-bottom': '@/components/controllable-drawer-buttom',
      'spring-icon': '@didi/spring-icon',
      Swiper: '@didi/spring-ui/ts-web-swiper'
    }
  }
</script>